import React, { FormEventHandler } from "react"
import { FormProvider } from "react-hook-form"

import classNames from "classnames"

import { FormProviderProps } from "shared/types/ReactHookForm"
import { WithClassName } from "shared/types/WithClassName"

import "widgets/product-position/product-position-form/styles/_product-position-form.scss"
import { ProductPositionQuantityInput } from "widgets/product-position/product-position-form/ui/inputs/ProductPositionQuantityInputBase"

import { MultiEditProductPositionFormData } from "../MultiEditProductPositionForm"

export interface MultiEditProductPositionFormOptions {
  hideQuantity?: boolean
}

interface MultiEditProductPositionFormViewModel extends WithClassName {
  id: string
  form: FormProviderProps<MultiEditProductPositionFormData>
  isReadonly?: boolean
  options?: MultiEditProductPositionFormOptions
  onSubmit: FormEventHandler
}

export const MultiEditProductPositionFormView = React.memo(
  ({
    id,
    form,
    isReadonly,
    className,
    options,
    onSubmit
  }: MultiEditProductPositionFormViewModel) => (
    <FormProvider {...form}>
      <form
        id={id}
        onSubmit={onSubmit}
        className={classNames("product-position-form multi-edit", className)}
      >
        {options?.hideQuantity ? null : (
          <ProductPositionQuantityInput readonly={isReadonly} />
        )}
      </form>
    </FormProvider>
  )
)
